export default __webpack_public_path__ + "static/car-f3236137d80bd22796627818dac15842.png";